export default __webpack_public_path__ + "static/media/scrabble-go@2x.cf3cd03a.webp";